import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

import {
  FontFamilies,
  FontSizes,
  Theme,
} from 'common';

const SOCIAL_LINK_ICONS = {
  facebook: 'M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z',
  instagram: 'M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077',
  x: 'M14.234 10.162 22.977 0h-2.072l-7.591 8.824L7.251 0H.258l9.168 13.343L.258 24H2.33l8.016-9.318L16.749 24h6.993zm-2.837 3.299-.929-1.329L3.076 1.56h3.182l5.965 8.532.929 1.329 7.754 11.09h-3.182z',
  tiktok: 'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z',
  youtube: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z',
  linkedin: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
  spotify: 'M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z',
};

const renderMarkdownLink = (label, href) => {
  const socialMatch = label.match(/^(facebook|instagram|x|tiktok|youtube|linkedin|spotify):(.*)$/i);
  const linkStyle = `font-family: ${FontFamilies.Regular} !important; text-decoration: underline; text-decoration-color: ${Theme.Markdown.TextColor};`;

  if (!socialMatch) {
    return `<a class="markdown-link" style="${linkStyle}" href="${href}" target="_blank" rel="noopener noreferrer">${label}</a>`;
  }

  const platform = socialMatch[1].toLowerCase();
  const linkLabel = socialMatch[2].trim();

  return `<a class="markdown-link markdown-social-link" style="font-family: ${FontFamilies.Regular} !important; display: inline-flex; align-items: center; gap: 0.35em; text-decoration: none;" href="${href}" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" width="1em" height="1em" aria-hidden="true" focusable="false" style="display: block; flex-shrink: 0;"><path fill="currentColor" d="${SOCIAL_LINK_ICONS[platform]}"></path></svg><span class="markdown-social-label" style="text-decoration: underline; text-decoration-color: ${Theme.Markdown.TextColor};">${linkLabel}</span></a>`;
};

export const Markdown = ({ markdown, defaultFontSize, padding, gap }) => {
  const renderedContent = useMemo(() => {
    if (!markdown) return '';
    
    // Helper function to process inline markdown elements
    const processInlineMarkdown = (text) => {
      return text
        // Code blocks (before other processing to avoid conflicts)
        //.replace(/`([^`]+)`/g, `<code style="background-color: #f4f4f4; padding: 2px 4px; border-radius: 3px; font-family: monospace; font-size: 0.9em;">$1</code>`)
        // Bold (improved pattern to handle text at beginning of line)
        .replace(/\*\*((?:[^*]|\*(?!\*))+)\*\*/g, `<span style="font-family: ${FontFamilies.Bold} !important;">$1</span>`)
        // Italic
        .replace(/_((?:[^_]|_(?!_))+)_/g, '<em>$1</em>')
        // Strikethrough
        .replace(/~~((?:[^~]|~(?!~))+)~~/g, '<del>$1</del>')
        // Links. A label like "instagram:Follow us" renders the platform icon plus the text after the colon.
        .replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_, label, href) => renderMarkdownLink(label, href));
    };

    const lines = markdown.split('\n');
    let html = '';
    let inList = false;
    let listType = null; // 'ul' or 'ol'
    let inCodeBlock = false;
    let codeBlockContent = '';
    let currentParagraph = '';
    let inParagraph = false;

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      const trimmedLine = line.trim();
      const nextLine = i < lines.length - 1 ? lines[i + 1].trim() : '';
      
      if (inCodeBlock) {
        codeBlockContent += (codeBlockContent ? '\n' : '') + line;
        continue;
      }
      
      // Check if this is a list item (unordered or ordered)
      const isUnorderedList = trimmedLine.match(/^[*-]\s+(.+)$/);
      const isOrderedList = trimmedLine.match(/^\d+\.\s+(.+)$/);
      
      if (isUnorderedList || isOrderedList) {
        // Close any open paragraph before starting a list
        if (inParagraph) {
          html += `<p style="line-height: 1.5; font-size: ${defaultFontSize ?? FontSizes.Small};">${currentParagraph}</p>`;
          currentParagraph = '';
          inParagraph = false;
        }

        const newListType = isUnorderedList ? 'ul' : 'ol';
        
        if (!inList || listType !== newListType) {
          // Close previous list if exists
          if (inList) {
            html += `</${listType}>`;
          }
          // Start a new list
          html += `<${newListType} class="markdown-${newListType}" style="font-size: ${defaultFontSize ?? FontSizes.Small}; margin: 0; padding-left: 20px;">`;
          inList = true;
          listType = newListType;
        }
        
        // Extract and process list item content
        const content = isUnorderedList ? isUnorderedList[1] : isOrderedList[1];
        const processedContent = processInlineMarkdown(content);
        html += `<li><span style="font-family: ${FontFamilies.Regular} !important;">${processedContent}</span></li>`;
      } else if (inList && trimmedLine === '' && !nextLine.match(/^(?:[*-]|\d+\.)\s+/)) {
        // Close the list if we have an empty line and next line is not a list item
        html += `</${listType}>`;
        inList = false;
        listType = null;
      } else if (!inList) {
        // Process other markdown elements
        let processed = '';
        
        // Headers
        if (trimmedLine.match(/^# /)) {
          // Close any open paragraph before starting a header
          if (inParagraph) {
            html += `<p style="line-height: 1.5; font-size: ${defaultFontSize ?? FontSizes.Small};">${currentParagraph}</p>`;
            currentParagraph = '';
            inParagraph = false;
          }
          
          // Process the header content for inline markdown
          const headerContent = trimmedLine.replace(/^#\s+/, '');
          const processedHeader = processInlineMarkdown(headerContent);
          processed = `<h1 style="font-family: ${FontFamilies.Regular} !important;">${processedHeader}</h1>`;
          html += processed;
        } else if (trimmedLine.match(/^## /)) {
          // Close any open paragraph before starting a header
          if (inParagraph) {
            html += `<p style="line-height: 1.5; font-size: ${defaultFontSize ?? FontSizes.Small};">${currentParagraph}</p>`;
            currentParagraph = '';
            inParagraph = false;
          }
          
          // Process the header content for inline markdown
          const headerContent = trimmedLine.replace(/^##\s+/, '');
          const processedHeader = processInlineMarkdown(headerContent);
          processed = `<h2 style="font-family: ${FontFamilies.Regular} !important;">${processedHeader}</h2>`;
          html += processed;
        } else if (trimmedLine.match(/^### /)) {
          // Close any open paragraph before starting a header
          if (inParagraph) {
            html += `<p style="line-height: 1.5; font-size: ${defaultFontSize ?? FontSizes.Small};">${currentParagraph}</p>`;
            currentParagraph = '';
            inParagraph = false;
          }
          
          // Process the header content for inline markdown
          const headerContent = trimmedLine.replace(/^###\s+/, '');
          const processedHeader = processInlineMarkdown(headerContent);
          processed = `<h3 style="font-family: ${FontFamilies.Regular} !important; font-size: 1.17em !important;">${processedHeader}</h3>`;
          html += processed;
        } else if (trimmedLine === '') {
          // Empty line - close current paragraph if exists
          if (inParagraph) {
            html += `<p style="line-height: 1.5; font-size: ${defaultFontSize ?? FontSizes.Small};">${currentParagraph}</p>`;
            currentParagraph = '';
            inParagraph = false;
          }
        } else {
          // Regular paragraph content
          processed = processInlineMarkdown(trimmedLine);
          
          if (processed.trim()) {
            if (inParagraph) {
              // Add a line break for single line breaks
              currentParagraph += '<br/>' + processed;
            } else {
              // Start a new paragraph
              currentParagraph = processed;
              inParagraph = true;
            }
          }
        }
      }
    }

    // Close any open paragraph at the end
    if (inParagraph) {
      html += `<p style="line-height: 1.5; font-size: ${defaultFontSize ?? FontSizes.Small};">${currentParagraph}</p>`;
    }

    // Close any open list at the end
    if (inList) {
      html += `</${listType}>`;
    }
    
    // Close any open code block at the end (shouldn't happen with well-formed markdown)
    if (inCodeBlock) {
      html += `<pre style="background-color: #f4f4f4; padding: 12px; border-radius: 6px; overflow-x: auto; font-family: monospace; font-size: 0.9em; line-height: 1.4;"><code>${DOMPurify.sanitize(codeBlockContent)}</code></pre>`;
    }

    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: ['h1', 'h2', 'h3', 'p', 'strong', 'em', 'code', 'pre', 'a', 'span', 'ul', 'ol', 'li', 'br', 'del', 'svg', 'path'],
      ALLOWED_ATTR: ['href', 'class', 'style', 'target', 'rel', 'viewBox', 'width', 'height', 'fill', 'd', 'aria-hidden', 'focusable']
    });
  }, [markdown, defaultFontSize]);

  return (
    <div 
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: gap ?? '20px',
        color: Theme.Markdown.TextColor,
        padding: padding ?? '0',
        fontSize: defaultFontSize ?? FontSizes.Small,
        lineHeight: 1.5,
      }}
      dangerouslySetInnerHTML={{ __html: renderedContent }}
    />
  );
};
